// One audible experience at a time; a reaction is an explicit video + audio pair.
document.addEventListener('play', event => {
  const media = event.target;
  if (!(media instanceof HTMLMediaElement) || media.classList.contains('hero-bg')) return;
  document.querySelectorAll('audio, video').forEach(other => {
    if (other === media) return;
    if (media.dataset.mediaGroup && media.dataset.mediaGroup === other.dataset.mediaGroup) return;
    other.pause();
  });
}, true);
